import actions from './actions';
import mutations from './mutations';
import * as getters from './getters';

const state = () => ({
  createAdminLeague: { data: null, loading: false, error: null },
  leagues: { data: null, loading: false, erorr: null },
  moreLeaguesLoading: false,
  pendingProfileInvitations: { data: null, loading: false, erorr: null },
  answerLeagueInvitation: { data: null, loading: false, erorr: null },
  league: {
    data: null,
    loading: null,
    error: null,
    feed: {
      data: null,
      loading: false,
      error: null,
      loadingNextPosts: false,
      leagueId: null,
    },
  },
  leagueRules: { data: null, loading: null, error: null },
  myLeaguePortfolios: { data: [], loading: false, error: null },
  leaguePortfolios: { data: [], loading: false, error: null },
  submitLeaguePassword: { data: null, loading: false, error: null },
});

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
